import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import { useMemo } from "react";
import { Icon } from "@syarahtech/ui";
var DownloadAppSection = function DownloadAppSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  var downloadAppItems = useMemo(function () {
    return [{
      key: "about_us/download_app_item1",
      text: tLong("about_us/download_app_item1", {
        ns: "web_common"
      })
    }, {
      key: "about_us/download_app_item2",
      text: tLong("about_us/download_app_item2", {
        ns: "web_common"
      })
    }, {
      key: "about_us/download_app_item3",
      text: tLong("about_us/download_app_item3", {
        ns: "web_common"
      })
    }];
  }, [tLong]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "px-4 pb-12 md:max-w-[1152px] md:mx-auto md:pb-[104px] md:px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-primary rounded-[32px] relative pt-[200px] mt-[180px] md:flex md:flex-row-reverse md:pt-0 md:relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute top-[-50%] w-full transform translate-y-1/2 md:top-0 md:left-0 md:translate-y-0 md:z-[3] md:h-full md:justify-end"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/iphone-mock.svg",
    alt: tLong("about_us/iphone-mock-alt", {
      ns: "web_common"
    }),
    loading: "lazy",
    className: "md:transform md:scale-[1.6] md:absolute md:left-[70px] lg:scale-[1.9] lg:left-[95px] en:lg:right-[95px] en:md:right-[95px] en:left-[unset]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-full relative overflow-hidden px-6 pb-[70px] pt-6 md:relative lg:pt-10 lg:pb-12 lg:px-[100px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 justify-center md:max-w-[590px]"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-white text-start text-2xl font-bold leading-8  lg:text-[40px] lg:leading-normal"
  }, tShort("about_us/download_app_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-base text-white font-regular leading-6 text-start lg:text-2xl lg:leading-normal"
  }, tLong("about_us/download_app_subtitle", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-col gap-7 z-10 relative md:max-w-[590px]"
  }, downloadAppItems.map(function (item) {
    return /*#__PURE__*/React.createElement(DownloadAppItem, {
      key: item.key,
      text: item.text
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mt-[34px] z-10 relative"
  }, /*#__PURE__*/React.createElement("a", {
    className: "flex items-center justify-center gap-4 w-full cursor-pointer md:hidden"
  }, /*#__PURE__*/React.createElement("img", {
    className: "rounded max-w-[50%] md:hidden",
    src: CDN_LINK + "/assets/images/about-us/store-android.svg",
    alt: tLong("about_us/store-android-alt"),
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("img", {
    className: "rounded max-w-[50%] md:hidden",
    src: CDN_LINK + "/assets/images/about-us/store-ios.svg",
    alt: tLong("about_us/store-ios-alt"),
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("a", {
    className: "hidden md:inline-flex rounded-lg bg-white px-8 py-4 text-center text-primary font-bold text-xl cursor-pointer hover:text-primary-110"
  }, tShort("about_us/download_app_cta", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-[545px] h-[545px] rounded-full border-[160px] border-solid border-[#FF6029] absolute bottom-[-300px] left-[-300px] z-[2] lg:w-[700px] lg:h-[700px] lg:left-[-300px] lg:bottom-[-300px] en:lg:left-[unset] en:lg:right-[-300px]"
  })))));
};
var DownloadAppItem = function DownloadAppItem(_ref) {
  var key = _ref.key,
    text = _ref.text;
  return /*#__PURE__*/React.createElement("li", {
    key: key,
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--check-circle-outline-rounded",
    width: 6,
    height: 6,
    variant: "white"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-white text-base font-regular leading-6 text-start lg:text-lg"
  }, text));
};
export default DownloadAppSection;